import ConfirmationIcon from "@mui/icons-material/ConfirmationNumber";
import type { FC } from "react";
import { useState } from "react";
import type { SavedOrder } from "../orderTypes";
import OrderConfirmationDialog from "./OrderConfirmationDialog";
import ButtonWithContextMenu from "../../components/buttonWithContextMenu/ButtonWithContextMenu";
import ConfirmationDialog from "../../components/confirmationDialog/ConfirmationDialog";
import { useCreateOrderConfirmation } from "./useCreateOrderConfirmation";

interface Props {
  readonly order: Pick<SavedOrder, "id" | "currency" | "name" | "products" | "currencyExchangeRate" | "start" | "type">;
}

const GenerateOrderConfirmationButton: FC<Props> = ({ order }) => {
  const [open, setOpen] = useState<"CUSTOMER" | "PILOT" | null>(null);
  const { createConfirmation } = useCreateOrderConfirmation(order);
  return (
    <>
      <ButtonWithContextMenu
        startIcon={<ConfirmationIcon />}
        color="secondary"
        variant="outlined"
        menuItems={[
          { name: "Potwierdzenie dla klienta", onClick: () => setOpen("CUSTOMER") },
          { name: "Potwierdzenie dla pilota", onClick: () => setOpen("PILOT") },
        ]}
      >
        Generuj potwierdzenie
      </ButtonWithContextMenu>
      <OrderConfirmationDialog open={open == "CUSTOMER"} order={order} onClose={() => setOpen(null)} />
      <ConfirmationDialog
        open={open === "PILOT"}
        title="Potwierdzenie dla pilota"
        content="Wygeneruj potwierdzenie ze szczegółami wyjazdu dla pilota wycieczki"
        confirmButtonText="Generuj"
        onConfirm={async () => {
          await createConfirmation({
            type: "PILOT_BRIEFING",
          });
          setOpen(null);
        }}
        onCancel={() => setOpen(null)}
      />
    </>
  );
};

export default GenerateOrderConfirmationButton;
